import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot } from 'firebase/firestore';

interface User {
  id: string;
  email: string;
}

interface UserListProps {
  onUserSelect: (userId: string) => void;
  currentUserId: string;
}

export const UserList: React.FC<UserListProps> = ({ onUserSelect, currentUserId }) => {
  const [users, setUsers] = useState<User[]>([]);

  useEffect(() => {
    console.log('UserList: Fetching users');
    const unsubscribe = onSnapshot(collection(db, 'users'), (snapshot) => {
      const userList = snapshot.docs
        .map(doc => ({ id: doc.id, email: doc.data().email as string }))
        .filter(user => user.id !== currentUserId);
      console.log('UserList: Users fetched', userList);
      setUsers(userList);
    });

    return () => unsubscribe();
  }, [currentUserId]);

  const handleCallClick = (userId: string) => {
    console.log('UserList: Call button clicked for user', userId);
    onUserSelect(userId);
  };

  return (
    <div>
      <h3>Available Users</h3>
      <ul>
        {users.map(user => (
          <li key={user.id}>
            {user.email}
            <button onClick={() => handleCallClick(user.id)}>Call</button>
          </li>
        ))}
      </ul>
    </div>
  );
};